// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useGetMultipleSalesInformations from "@store/Framework/Store/Data/Products/ProductsHooks/useGetMultipleSalesInformations";
import { InfosBoxStyles } from "@store/Library/Components/Toolkit/InfosBox";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

const InfosBox = getWidgetComponent("InfosBox");

type StoreProductMultipleSalesProps = { warning?: boolean; qty?: number };
type StoreMultipleSalesMessageProps = {
    qty?: number;
    warning?: boolean;
    extendedStyles?: StoreMultipleSalesMessageStyle;
    overrideStyles?: StoreMultipleSalesMessageStyle;
};

export interface StoreProductMultipleSalesStyle {
    infosBoxStyles?: InfosBoxStyles;
}

const styles: StoreProductMultipleSalesStyle = {
    infosBoxStyles: {
        wrapper: {
            css: css`
                border-radius: ${pxToRem(4)} !important;
            `,
        },
    },
};

const StoreProductMultipleSales: FC<StoreProductMultipleSalesProps> = ({ warning, qty }) => {
    let { multipleSaleQty } = useGetMultipleSalesInformations();
    multipleSaleQty = qty || multipleSaleQty;
    const message = () => {
        return (
            <StyledWrapper>
                <Typography>{`${translate(`MultipleSaleQty`)} ${multipleSaleQty}`}</Typography>
            </StyledWrapper>
        );
    };

    if (multipleSaleQty > 1) {
        if (warning) {
            return <InfosBox type="default" size="tiny" content={message()} extendedStyles={styles.infosBoxStyles} />;
        }
        return message();
    }

    return null;
};

export interface StoreMultipleSalesMessageStyle {
    wrapper?: InjectableCss;
    message?: TypographyPresentationProps;
}

export const storeMultipleSalesMessageStyle: StoreMultipleSalesMessageStyle = {};

export const StoreMultipleSalesMessage: FC<StoreMultipleSalesMessageProps> = ({ warning, qty, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(storeMultipleSalesMessageStyle, extendedStyles));
    const message = () => {
        return (
            <StyledWrapper {...styles.wrapper}>
                <Typography {...styles.message}>{`${translate(`MultipleSaleQty`)} ${qty}`}</Typography>
            </StyledWrapper>
        );
    };

    if (qty && qty > 1) {
        if (warning) {
            return <InfosBox type="default" size="tiny" content={message()} />;
        }
        return message();
    }

    return null;
};
export default StoreProductMultipleSales;
